import { request } from "./http";

export interface ShopSku {
  id: string;
  sku_code: string;
  name: string;
  price_cents: number;
  currency: string;
  billing_type: string;
  entitlement_kind: string;
  entitlement_ref: string | null;
  duration_days: number | null;
}

export interface ShopProduct {
  id: string;
  slug: string;
  kind: string;
  name: string;
  summary: string | null;
  description_md: string | null;
  status: string;
  metadata: Record<string, unknown>;
  skus: ShopSku[];
}

export interface ProductCreate {
  slug: string;
  kind: string;
  name: string;
  summary?: string | null;
  description_md?: string | null;
  status?: string;
  sort_order?: number;
}

export interface SkuCreate {
  sku_code: string;
  name: string;
  price_cents: number;
  currency?: string;
  billing_type?: string;
  entitlement_kind: string;
  entitlement_ref?: string | null;
  duration_days?: number | null;
  active?: boolean;
}

export interface GrantRequest {
  user_id: string;
  sku_code: string;
  entitlement_kind: string;
  entitlement_ref?: string | null;
  duration_days?: number | null;
}

export const commerceAdmin = {
  listProducts: () =>
    request<{ products: ShopProduct[] }>("/api/v1/shop/admin/products").then((r) => r.products),
  createProduct: (body: ProductCreate) =>
    request<ShopProduct>("/api/v1/shop/admin/products", { body }),
  createSku: (productId: string, body: SkuCreate) =>
    request<ShopSku>(`/api/v1/shop/admin/products/${productId}/skus`, { body }),
  grant: (body: GrantRequest) =>
    request<{ granted: boolean }>("/api/v1/shop/admin/grant", { body }),
};
